import {
  formatBoolean,
  FormattedDate,
  getIsoDateFromFormattedDate,
  ISODate,
} from '../../utils';
import { FilterTransformer } from './types';

export const serializeValueDate = ((id, value) => {
  if (id === 'valueDate') {
    const { onlyLastValueDate, valueDate } = (value || {}) as {
      onlyLastValueDate?: boolean;
      valueDate?: [FormattedDate, FormattedDate];
    };
    return {
      valueDate: valueDate?.map(getIsoDateFromFormattedDate),
      onlyLastValueDate: formatBoolean(onlyLastValueDate),
    };
  }

  return { [id]: value };
}) satisfies FilterTransformer;

export const deserializeValueDate = ((id, value, allQueryFilters) => {
  if (id === 'valueDate' || id === 'onlyLastValueDate') {
    const { onlyLastValueDate, valueDate } = allQueryFilters as {
      onlyLastValueDate?: boolean;
      valueDate?: [ISODate, ISODate];
    };

    return {
      valueDate:
        onlyLastValueDate || valueDate
          ? {
              onlyLastValueDate: formatBoolean(onlyLastValueDate),
              valueDate: valueDate,
            }
          : undefined,
    };
  }

  return { [id]: value };
}) satisfies FilterTransformer;
